import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, map, take } from "rxjs/operators";
import { AppState, stateGetter } from "../store/state/app.state";

@Injectable({
  providedIn: "root",
})
export class RouteGuardService implements CanActivate {
  constructor(
    private router: Router,
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const home = this.router.createUrlTree(["/home"]);
    if (route.routeConfig.path === ":ticker/events") {
      return this.store
        .select(stateGetter("globalHeader", "globalSettings"))
        .pipe(
          filter((data) => Object.keys(data).includes("events_access")),
          take(1),
          map((data) => data.events_access || home),
        );
    }

    if (route.routeConfig.path === ":ticker/revisions/:tickerType") {
      const ticker = route.params.ticker;
      const tickerType = route.params.tickerType;
      if (tickerType !== undefined) {
        this.http
          .get(
            `${window.apiUrl}/api/convert_bloomberg_ticker_to_va_ticker?ticker=${ticker}&tickertype=b`,
          )
          .subscribe(
            (res: any) => {
              if (res.status === "success") {
                this.router.navigate(["company", `${res.ticker}`, "revisions"]);
              } else {
                this.router.navigateByUrl("/home");
              }
            },
            () => {
              this.router.navigateByUrl("/home");
            },
          );
      } else {
        return true;
      }
    }

    return false;
  }
}
